import { render, staticRenderFns } from "./AgroTablePagination.vue?vue&type=template&id=402dbe72&scoped=true&"
import script from "./AgroTablePagination.vue?vue&type=script&lang=ts&"
export * from "./AgroTablePagination.vue?vue&type=script&lang=ts&"
import style0 from "./agroTablePagination.scss?vue&type=style&index=0&id=402dbe72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402dbe72",
  null
  
)

export default component.exports